module.exports = __webpack_public_path__ + "static/img/3.65775b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/3.png
// module id = RSjF
// module chunks = 0